var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18676 7.81313L9.76792 2.23194C9.99179 2.00809 10.3648 2.23862 10.2647 2.53894L8.88592 6.6752C8.77799 6.999 9.01898 7.33333 9.36025 7.33333H11.4595C11.9049 7.33333 12.128 7.87193 11.813 8.18687L6.2318 13.7681C6.00796 13.9919 5.63496 13.7614 5.73507 13.4611L7.11385 9.3248C7.22178 9.001 6.98078 8.66667 6.63949 8.66667H4.5403C4.09486 8.66667 3.87177 8.12807 4.18676 7.81313Z",
    stroke: "#F3F4F5",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.db916d70e54bb34eb696fe37d41e79a6.svg";
export { ForwardRef as ReactComponent };